import { useState, useEffect } from "react";
import { FetchVariable } from "../../../Components/FetchVariable/FetchVariable";
import { Line } from '@ant-design/plots';
import { Card } from 'antd';
import axios from 'axios'

function VehicleSaleReport(){
    const [data, setData] = useState([]);

    useEffect(() => {
      let apiURL= `${FetchVariable.Heroku}/vehicle/vehicle-sale-report`
      axios.get(apiURL)
        .then((res)=>{
          let data = res.data
          let array=[]

          data.map((e)=>{
            return array.push({SalesDate: e.SalesDate,SalesPrice:parseInt(e.SalesPrice)})
          })
          setData(array)

        })    
    }, []);
  
    const config = {
      data,
      padding: 'auto',
      xField: 'SalesDate',
      yField: 'SalesPrice',
      xAxis: {
        tickCount: 5,
      },
      smooth: true,
    };
      return(
          <>
            <Card>
              <Line {...config} />
            </Card>
          </>
      )
}
export default VehicleSaleReport